import { useSelector } from 'react-redux';
import cartUtils from '../utils/cart';

export const usePreCartOfferProductsToPrompt = () => {
  const { preCartOfferProducts, triggersPreCartOfferProducts } = useSelector(
    (state) => state.shoot,
  );
  const selectedStudentId = useSelector(
    (state) => state.additionalData.selectedStudent?.id,
  );
  const shootEventId = useSelector((state) => {
    const s = state.shoot.shoot;
    return s?.event_id || s?.id;
  });
  const orderKey =
    shootEventId && selectedStudentId
      ? `${shootEventId}-${selectedStudentId}`
      : null;
  const currentOrder = useSelector((state) =>
    orderKey ? state.v3Order.orders[orderKey] : undefined,
  );

  return cartUtils.preCartOfferProductsToPrompt(
    currentOrder,
    preCartOfferProducts,
    triggersPreCartOfferProducts,
  );
};
